import { Outlet } from '@tanstack/react-router'

import { cn } from '@/lib/utils'

import { PageTabs } from '../ui/page-tabs/page-tabs'
import { TASK_MANAGEMENT_TAB_ITEMS } from './constants'

export const DashboardTaskManagementLayout = () => {
  return (
    <div className={cn('mt-5', 'p-5', 'rounded-lg border border-border', 'shadow-sm')}>
      <PageTabs items={TASK_MANAGEMENT_TAB_ITEMS} />

      <Outlet />
    </div>
  )
}
